const TAIICHI_OHNO = 'Taiichi Ohno - Créateur du Toyota Production System';
const HENRY_FORD = 'Henry Ford - Fondateur de Ford Motor Company';
const ED_DEMING = 'Edward Deming - Créateur du PDCA';

export const HAVING_NO_PROBLEMS = 'Ne pas avoir de problèmes est le plus gros problème.';
export const HAVING_NO_PROBLEMS_SOURCE = TAIICHI_OHNO;

export const FORCE_STANDARDS = 'Les standards ne doivent pas être imposés par le top management mais définis par les travailleurs du terrain.';
export const FORCE_STANDARDS_SOURCE = TAIICHI_OHNO;

export const WASTE = 'Le gaspillage est tout sauf la quantité minimum requise de machines, de matériaux, de pièces et de temps de travail, absolument essentielle à la création de produit ou service.';
export const WASTE_SOURCE = TAIICHI_OHNO;

export const ALWAYS_DO_WHAT_ALWAYS_DID = 'Si vous continuez à faire ce que vous avez toujours fait, vous obtiendrez encore ce que vous avez toujours obtenu.';
export const ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE = HENRY_FORD;

export const FIND_FAULT = 'Ne cherchez pas la faute, cherchez le remède.';
export const FIND_FAULT_SOURCE = HENRY_FORD;

export const BAD_SYSTEM = 'Un mauvais système triomphera toujours d\'une bonne personne.';
export const BAD_SYSTEM_SOURCE = ED_DEMING;

export const WITHOUT_DATA = 'Sans donnée, vous n\'êtes que quelqu\'un avec une opinion.';
export const WITHOUT_DATA_SOURCE = ED_DEMING;

export default {
  HAVING_NO_PROBLEMS,
  HAVING_NO_PROBLEMS_SOURCE,
  FORCE_STANDARDS,
  FORCE_STANDARDS_SOURCE,
  WASTE,
  WASTE_SOURCE,
  ALWAYS_DO_WHAT_ALWAYS_DID,
  ALWAYS_DO_WHAT_ALWAYS_DID_SOURCE,
  FIND_FAULT,
  FIND_FAULT_SOURCE,
  BAD_SYSTEM,
  BAD_SYSTEM_SOURCE,
  WITHOUT_DATA,
  WITHOUT_DATA_SOURCE,
}
